import { render, staticRenderFns } from "./ColorPickerBlock.vue?vue&type=template&id=3a8be43a&scoped=true&"
import script from "./ColorPickerBlock.vue?vue&type=script&lang=js&"
export * from "./ColorPickerBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerBlock.vue?vue&type=style&index=0&id=3a8be43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8be43a",
  null
  
)

export default component.exports